const TOKEN_KEY = "api_token";

export function getToken() {
  return localStorage.getItem(TOKEN_KEY) || "";
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

async function request(path, { method = "GET", body } = {}) {
  const token = getToken();
  const headers = {
    "content-type": "application/json",
  };
  if (token) headers["authorization"] = `Bearer ${token}`;

  const res = await fetch(path, {
    method,
    headers,
    body: body ? JSON.stringify(body) : undefined,
  });

  const text = await res.text();
  const data = text ? JSON.parse(text) : null;

  if (!res.ok) {
    const msg = data && data.error ? data.error : `HTTP ${res.status}`;
    const err = new Error(msg);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const api = {
  // items
  listItems(params = {}) {
    const qs = new URLSearchParams(params).toString();
    return request(`/api/items${qs ? `?${qs}` : ""}`);
  },
  createItem(payload) {
    return request(`/api/items`, { method: "POST", body: payload });
  },
  setItemStatus(id, payload) {
    return request(`/api/items/${id}/status`, { method: "POST", body: payload });
  },

  // item
  updateItem(id,payload){
    return request(`/api/items/${id}`, { method: "PUT", body: payload });
  },

  // categories
  listCategories() {
    return request(`/api/categories`);
  },
  createCategory(payload) {
    return request(`/api/categories`, { method: "POST", body: payload });
  },

  // auth check
  ping() {
    // 用 categories 作为一个轻量鉴权检测
    return request(`/api/categories`);
  }
};